(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    /**
     * The controller for the account self-edit page. Referenced from every app that allows the user to edit his own profile. The
     * example code below shows how to hook up the account controller.
     * @ngdoc controller
     * @name AccountCtrl
     * @memberOf ihh-common-web
     * @example
     * angular.module('someModule').config(
     *
     * ['$routeProvider',
     *
     * function($routeProvider) {
     *     // Other config code, including other routes
     *     $routeProvider.when('/manage-account', {
             controller: 'AccountCtrl',
             templateUrl: 'user/manage-account.tpl.html'
           });
     * }]);
     */
    angular
        .module('ihh-common-web')
        .controller('AccountCtrl', AccountCtrl);

    AccountCtrl.$inject = ['$scope', 'RestResources', 'Utilities', 'IhhMedia', '$q'];

    function AccountCtrl($scope, RestResources, Utilities, IhhMedia, $q) {
        var personId = $scope.user.self.id;
        var selfResource = RestResources.getSelfResource(personId);

        $scope.getPerson = function() {
            return $scope.isEdit ? $scope.personTemp : $scope.person;
        };

        $scope.person = selfResource.get();
        $scope.personTemp = {};

        $scope.suppressActive = true;
        $scope.isEdit = false;

        $scope.getActive = function() {
            return $scope.isEdit ? $scope.personTemp && $scope.personTemp.active : $scope.person && $scope.person.active;
        };

        $scope.setActive = function(active) {
            if ($scope.personTemp.active !== active) {
                $scope.personTemp.active = active;
                $scope.profileForm.$setDirty();
            }
        };

        $scope.formatActive = function(value) {
            return value ? 'Active' : 'Inactive';
        };

        $scope.cancel = function() {
            $scope.isEdit = false;
            $scope.profileForm.$setPristine();
        };

        $scope.edit = function() {
            $scope.personTemp = angular.copy($scope.person);
            $scope.isEdit = true;
        };

        $scope.save = function() {
            if (!$scope.profileForm.$invalid) {
                var deferred = $q.defer();
                $scope.saving = deferred.promise;
                $scope.saving.then(function () {
                    $scope.saving = false;
                });

                selfResource.update($scope.personTemp, function(result) {
                    $scope.person = result;
                    $scope.profileForm.$setPristine();
                    $scope.refreshSelf();
                    $scope.isEdit = false;
                    $scope.profileForm.$setPristine();
                    deferred.resolve();
                }, function(err) {
                    RestResources.reportRestError('Could not update self', err);
                    deferred.resolve();
                });
            }
        };

        $scope.chooseThumbnail = function() {
            var resource = RestResources.getPersonImagesResource(personId);
            IhhMedia.chooseThumbnail(resource, 'My Profile Picture', 'Click the button and select an image to use for your profile picture.', function(name) {
                $scope.profileForm.$setDirty();
                $scope.personTemp.thumbnail = name;
                $scope.personTemp.thumbnailUrl = RestResources.getPersonImageUrl($scope.personTemp.id, $scope.personTemp.thumbnail);
            }, function(err) {
                RestResources.reportRestError('Could not upload image', err);
            });
        };

        $scope.deleteThumbnail = function() {
            $scope.profileForm.$setDirty();
            delete $scope.personTemp.thumbnail;
            delete $scope.personTemp.thumbnailUrl;
        };

        $scope.changePassword = function() {
            Utilities.modal('user/change-password.tpl.html', 'ChangePasswordCtrl', {
                config: function() {
                    return {};
                }
            }, function(passwordChangeRequest) {
                var resource = RestResources.getPersonPasswordResource(personId);
                resource.update({}, passwordChangeRequest, function() {}, function(err) {
                    RestResources.reportRestError('Could not update password', err);
                });
            });
        };

        $scope.getThumbnailUrl = function() {
            return $scope.getUserThumbnailUrl($scope.person);
        };

        $scope.getTempThumbnailUrl = function() {
            return $scope.getUserThumbnailUrl($scope.personTemp);
        };

        // this is only required because it has no parent controller which instantiated the form first
        var unwatchFormInit = $scope.$watch('profileForm', function(theForm) {
            if (theForm) {
                Utilities.confirmAway($scope, $scope.profileForm);
                unwatchFormInit();
            }
        });
    }
})();